/* Legacy code - ignore this errors */
/* eslint class-methods-use-this: 0 */
import React from "react";
import { observer, Provider } from "mobx-react";
import Flexbox from "flexbox-react";
import AppStore from "../stores/AppStore";
import ItemStore from "../stores/ItemStore";
import TemplateStore from "../stores/TemplateStore";
import CurrentUserStore from "../stores/CurrentUserStore";
import UserProfileStore from "../stores/UserProfileStore";
import UserProfileTemplateStore from "../stores/UserProfileTemplateStore";
import ToastStore from "../stores/ToastStore";
import ItemActions from "../actions/ItemActions";
import StoreTemplateStore from "../stores/StoreTemplateStore";
import StoreTemplateActions from "../actions/StoreTemplateActions";
import TemplateActions from "../actions/TemplateActions";
import UserProfileTemplateHeader from "../components/user_profile_template/UserProfileTemplateHeader";
import UserProfileTemplate from "../components/user_profile_template/UserProfileTemplate";
import UserProfileEditTemplate from "../components/user_profile_template/UserProfileEditTemplate";
import SkeletonTitle from "../components/skeletons/SkeletonTitle";
import SkeletonRows from "../components/skeletons/SkeletonRows";
import ErrorBoundary from "../components/errors/ErrorBoundary";
import _ from "lodash";
import UserProfileTemplateV2 from "../components/user_profile_sync_data/UserProfileTemplateV2";
import axios from "axios";
import Cookies from "js-cookie";

@observer
export default class UserProfileTemplateView extends React.Component {
  state = {
    checkExists: null, // will be true/false after API call
    checking: true,
  };

  componentDidMount() {
    UserProfileTemplateStore.resetStartingAttributes();
    UserProfileStore.fetchAuthorizedAccounts(UserProfileStore.user.id)
      .then(() => {
        TemplateActions.fetchProfileTemplates()
          .then((response) => {
            _.map(response.data, (profileTemplate) => {
              UserProfileTemplateStore.addProfileTemplate(profileTemplate);
            });
            UserProfileTemplateStore.matchActiveProfileTemplate(
              UserProfileStore.authorizedAccount
            );
            UserProfileTemplateStore.toggleLoading();

            // --- Call check_v2 API here ---
           // const userId = CurrentUserStore.currentUser.id;
           const userId = UserProfileStore.user.id; 
           const firstTemplate = UserProfileTemplateStore.profileTemplates.find(
            (t) => t.defaultTemplate === true
          );
            if (firstTemplate && firstTemplate.id) {
              axios
                .get(
                  `${Cookies.get("apiEnv")}/fetch_profile_data/profile_conditions/check_v2?user_id=${userId}&profile_template_id=${firstTemplate.id}`
                )
                .then((res) => {
                  this.setState({
                    checkExists: res.data.exists,
                    checking: false,
                  });
                })
                .catch((err) => {
                  console.error("check_v2 API error:", err);
                  this.setState({ checkExists: false, checking: false });
                });
            } else {
              this.setState({ checkExists: false, checking: false });
            }
          })
          .catch(() => {
            UserProfileTemplateStore.toggleLoading();
          });
      })
      .catch(() => {
        UserProfileTemplateStore.toggleLoading();
      });
  }

  renderProfileTemplate() {
    if (UserProfileTemplateStore.isEditingTemplate) {
      return <UserProfileEditTemplate />;
    }
    return <UserProfileTemplate />;
  }


  render() {
    const stores = {
      CurrentUserStore,
      AppStore,
      ItemStore,
      TemplateStore, 
      ItemActions,
      UserProfileStore,
      UserProfileTemplateStore,
      StoreTemplateStore,
      StoreTemplateActions,
      TemplateActions,
      ToastStore,
    };
    const userId = UserProfileStore.user.id;

    if (
      CurrentUserStore.isLoading ||
      UserProfileTemplateStore.isLoading ||
      UserProfileStore.isLoading ||
      this.state.checking
    ) {
      return (
        <Flexbox
          flexGrow={1}
          flexDirection="column"
          className="fixed-width-container"
        >
          <SkeletonTitle />
          <Flexbox paddingTop="50px" paddingBottom="50px" flexGrow={1}>
            <SkeletonRows numRows={4} />
          </Flexbox>
        </Flexbox>
      );
    }

    return (
      <Provider {...stores}>
        <ErrorBoundary>
          <Flexbox
            flexGrow={1}
            flexDirection="column"
            className="profile-container"
          > 
            {this.state.checkExists ? (
              userId && <UserProfileTemplateV2 userId={userId} />
            ) : (
              <>
                <UserProfileTemplateHeader />
                {this.renderProfileTemplate()}
              </>
            )}          
          </Flexbox>
        </ErrorBoundary>
      </Provider>
    );
  }
}



